import { Routes, Route } from "react-router-dom";
import VehicleListingListScreen from "screens/App/CRM/VehicleListing/VehicleListingListScreen";
import VehicleListingDetailScreen from "screens/App/CRM/VehicleListing/VehicleListingDetailScreen";
import VehicleListingEditScreen from "screens/App/CRM/VehicleListing/VehicleListingEditScreen";
import VehicleListingCreateScreen from "screens/App/CRM/VehicleListing/VehicleListingCreateScreen";
import { NotFoundScreen } from "screens/NotFoundScreen";

const VehicleListingRouter = () => {
  return (
    <Routes>
      <Route path="list" element={<VehicleListingListScreen />} />
      <Route path="create" element={<VehicleListingCreateScreen />} />
      <Route path=":id/detail" element={<VehicleListingDetailScreen />} />
      <Route path=":id/edit" element={<VehicleListingEditScreen />} />
      <Route path="*" element={<NotFoundScreen />} />
    </Routes>
  );
};

export default VehicleListingRouter;